export default "<router-outlet (click)=\"moveUp()\"></router-outlet>\n";